import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import classNames from "classnames";

import { CFormGroup, CLabel, CModal } from "@coreui/react";

import { CButton } from "../../controls";

import placeholder from "./placeholder.jpg";

export const CViewImage = ({
  src = "",
  maxWidth = 140,
  aspectRatio = "square", //note: "square" | 1/1 | 4/3 |...
  className,
  label = "",
}) => {
  //#region Data
  const [imgSrc, setImgSrc] = useState(src ?? "");

  const popupRef = useRef(null);
  //#endregion

  useEffect(() => {
    setImgSrc(src ?? "");
  }, [src]);

  //#region Render
  return (
    <>
      <CFormGroup className={classNames("c-input", className)}>
        {label && <CLabel>{label}</CLabel>}

        <div
          className="relative rounded-lg overflow-hidden border border-gray-300 cursor-pointer"
          style={{
            width: maxWidth,
            aspectRatio:
              aspectRatio === "freestyle"
                ? undefined
                : aspectRatio === "square"
                ? "1/1"
                : aspectRatio,
          }}
          onClick={() => popupRef.current?.open()}
        >
          <img
            src={imgSrc}
            onError={() => setImgSrc(placeholder)}
            alt=""
            className="object-cover w-full h-full inset-0 absolute"
          />
        </div>
      </CFormGroup>

      <ImagePopup src={imgSrc} ref={popupRef} />
    </>
  );
  //#endregion
};

const ImagePopup = forwardRef(({ src }, ref) => {
  //#region Data
  const [open, setOpen] = useState(false);
  //#endregion

  //#region Event
  const onClose = () => setOpen(false);
  //#endregion

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
  }));

  //#region Render
  return (
    <CModal show={open} onClose={onClose} centered closeOnBackdrop={false}>
      <div className="flex flex-col p-3 items-center justify-center max-w-[800px]">
        <img src={src} alt="" className="max-w-full h-auto object-cover" />
        <div className="flex justify-center mt-4">
          <CButton onClick={onClose} className="!mr-0">
            Đóng
          </CButton>
        </div>
      </div>
    </CModal>
  );
  //#endregion
});
